<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    :width="width"
    :max-width="width"
    :disabled="disabled"
  >
    <v-text-field
      solo
      slot="activator"
      :label="label"
      :value="time"
      :disabled="disabled"
      :loading="loading"
      :error-messages="errorMessages"
      :error-count="errorCount"
      :error="error"
      :hide-details="hideDetails"
      :append-icon="appendIcon"
      :prepend-icon="prependIcon"
      readonly>
    </v-text-field>

    <v-time-picker
      full-width
      :key="timePickerKey"
      :width="width"
      class="v-time-picker-custom"
      v-model="timeComputed"
      scrollable
      :format="timePickerFormat"
      @click:minute="$refs.menu.save(time)"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'PosTimePicker',
  model: {
    prop: 'time',
    event: 'input',
  },
  props: {
    time: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 290,
    },
    format: {
      type: String,
      default: 'HH:mm',
    },
    timePickerFormat: {
      type: String,
      default: '24hr',
    },
    locale: {
      type: String,
      default: 'en-us',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [String, Array],
      default: () => [],
    },
    errorCount: {
      type: [Number, String],
      default: 1,
    },
    error: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    appendIcon: {
      type: String,
    },
    prependIcon: {
      type: String,
    },
  },
  data() {
    return {
      timePickerKey: 0,
      menu: false,
    };
  },
  computed: {
    timeComputed: {
      get() {
        return this.time;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch:{
    time(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.timePickerKey += 1;
      }
    },
  },
};
</script>
